/* React */
import React, { useState } from "react";

/* Simple Bar */
import SimpleBar from "simplebar-react";

/* Ionic */
import { IonBackdrop } from "@ionic/react";
import { close, information } from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./InfoIconWrapper.module.scss";
import "simplebar-react/dist/simplebar.min.css";

/* Interfaces */
interface InfoIconWrapperProps {
  children: React.ReactNode;
}

const InfoIconWrapper: React.FC<InfoIconWrapperProps> = ({
  children,
}) => {
  const [showContent, setShowContent] =
    useState<boolean>(false);

  return (
    <div className={styles.info_icon_wrapper}>
      <PrimaryFabButton
        className="primary small"
        ariaLabel={"Info Button"}
        icon={showContent ? close : information}
        onClick={() => {
          setShowContent(!showContent);
        }}
        scssProps={{
          position: "relative",
          zIndex: 1000,
        }}
      />
      {showContent ? (
        <>
          <SimpleBar className={styles.content_container}>
            {children}
          </SimpleBar>
          <IonBackdrop
            className={styles.backdrop}
            onIonBackdropTap={() => setShowContent(false)}
          />
        </>
      ) : undefined}
    </div>
  );
};

export default InfoIconWrapper;
